import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useSectionMeta } from "@/context/SiteConfigContext";
import { api } from "@/lib/api";
import { localizedSlug } from "@/lib/utils";
import { SectionHead, MaskWords, SectionButtons } from "@/components/site/primitives";
import { Reveal } from "@/components/site/Reveal";

export default function HomeJournal() {
  const { lang, t } = useLang();
  const c = t.home_journal || {};
  const meta = useSectionMeta("home_journal");
  const [essays, setEssays] = useState([]);

  useEffect(() => {
    api.get("/essays").then((r) => setEssays(r.data.slice(0, 3))).catch(() => setEssays([]));
  }, []);

  const g = (e, k) => e[`${k}_${lang}`] || e[`${k}_ro`] || "";
  if (!essays.length) return null;

  return (
    <section
      id="home_journal"
      data-testid="home-journal"
      className="bg-paper text-ink px-6 md:px-12 lg:px-20 py-28 md:py-40"
    >
      <SectionHead label={c.label} index="" />
      <div className="mt-10 md:mt-14 grid grid-cols-12 gap-6 items-end mb-12 md:mb-16">
        <MaskWords
          Tag="h2"
          text={c.title}
          className="col-span-12 lg:col-span-8 display uppercase text-[12vw] lg:text-[8vw] leading-[0.85] break-words"
        />
        <p className="col-span-12 lg:col-span-4 text-ink/65 leading-[1.6]">{c.intro}</p>
      </div>

      <div className="border-t border-ink/15">
        {essays.map((e, i) => (
          <Reveal key={e.id}>
            <Link
              to={`/journal/${localizedSlug(e, lang)}`}
              data-testid={`home-essay-${i}`}
              data-cursor="link"
              className="group grid grid-cols-12 gap-6 py-8 md:py-11 border-b border-ink/15 items-baseline"
            >
              <div className="col-span-12 lg:col-span-2 eyebrow text-ink/45 flex justify-between lg:block">
                <span>{g(e, "category")}</span>
                <span className="tnum">{e.reading_time}</span>
              </div>
              <h3 className="col-span-12 lg:col-span-7 serif text-3xl md:text-5xl leading-[1.02] transition-transform duration-500 group-hover:translate-x-2">
                {g(e, "title")}
              </h3>
              <p className="col-span-12 lg:col-span-3 text-ink/65 leading-[1.55] flex items-end justify-between gap-4">
                <span className="line-clamp-2">{g(e, "excerpt")}</span>
                <ArrowRight
                  size={20}
                  className="shrink-0 opacity-0 -translate-x-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-x-0"
                />
              </p>
            </Link>
          </Reveal>
        ))}
      </div>

      <div className="mt-12 md:mt-16">
        <SectionButtons buttons={meta.buttons} />
      </div>
    </section>
  );
}
